"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideSaveNeeded = exports.saveNeededStarted = exports.showSaveNeeded = exports.setOnlineStatus = exports.clearAppFeedbackMessage = exports.appFeedbackMessageSuccess = exports.appFeedbackMessageError = exports.SAVE_NEED_STARTED = exports.HIDE_SAVE_NEEDED = exports.SHOW_SAVE_NEEDED = exports.SET_ONLINE_STATUS = exports.CLEAR_APP_FEEDBACK_MESSAGE = exports.APP_FEEDBACK_MESSAGE_SUCCESS = exports.APP_FEEDBACK_MESSAGE_ERROR = void 0;
exports.default = reducer;
exports.doSave = doSave;
exports.cancel = cancel;
exports.checkConnectionStatusContinually = checkConnectionStatusContinually;
const app_1 = require("selectors/app");
// Actions
exports.APP_FEEDBACK_MESSAGE_ERROR = 'APP_FEEDBACK_MESSAGE_ERROR';
exports.APP_FEEDBACK_MESSAGE_SUCCESS = 'APP_FEEDBACK_MESSAGE_SUCCESS';
exports.CLEAR_APP_FEEDBACK_MESSAGE = 'CLEAR_APP_FEEDBACK_MESSAGE';
exports.SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';
exports.SHOW_SAVE_NEEDED = 'SHOW_SAVE_NEEDED';
exports.HIDE_SAVE_NEEDED = 'HIDE_SAVE_NEEDED';
exports.SAVE_NEED_STARTED = 'SAVE_NEED_STARTED';
// Reducer
const initialState = {
    online: false,
    feedbackMessage: {
        showFeedback: false,
        message: null,
        isError: null,
    },
    saveNeeded: {
        showSaveNeeded: false,
        message: null,
        saving: false,
        cancel: null,
        onSave: null,
        onSaveError: null,
    },
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'APP_FEEDBACK_MESSAGE_ERROR':
            const errorText = action.data;
            return {
                ...state,
                feedbackMessage: {
                    showFeedback: true,
                    message: errorText,
                    isError: true,
                },
            };
        case 'APP_FEEDBACK_MESSAGE_SUCCESS':
            const successText = action.data;
            return {
                ...state,
                feedbackMessage: {
                    showFeedback: true,
                    message: successText,
                    isError: false,
                },
            };
        case 'CLEAR_APP_FEEDBACK_MESSAGE':
            return {
                ...state,
                feedbackMessage: {
                    showFeedback: false,
                    message: null,
                    isError: null,
                },
            };
        case 'SET_ONLINE_STATUS':
            const online = action.data;
            return {
                ...state,
                online: online,
            };
        case 'SHOW_SAVE_NEEDED':
            const saveNeeded = action.data;
            return {
                ...state,
                saveNeeded: {
                    showSaveNeeded: true,
                    message: saveNeeded.message,
                    saving: saveNeeded.saving,
                    cancel: saveNeeded.cancel,
                    onSave: saveNeeded.onSave,
                    onSaveError: saveNeeded.onSaveError,
                },
            };
        case 'SAVE_NEED_STARTED':
            const saveNeededData = action.data;
            return {
                ...state,
                saveNeeded: {
                    showSaveNeeded: true,
                    message: saveNeededData.message,
                    saving: true,
                    cancel: saveNeededData.cancel,
                    onSave: saveNeededData.onSave,
                    onSaveError: saveNeededData.onSaveError,
                },
            };
        case 'HIDE_SAVE_NEEDED':
            return {
                ...state,
                saveNeeded: initialState.saveNeeded,
            };
        default:
            return state;
    }
}
// Action Creators
const appFeedbackMessageError = (data) => {
    return { type: exports.APP_FEEDBACK_MESSAGE_ERROR, data };
};
exports.appFeedbackMessageError = appFeedbackMessageError;
const appFeedbackMessageSuccess = (data) => {
    return { type: exports.APP_FEEDBACK_MESSAGE_SUCCESS, data };
};
exports.appFeedbackMessageSuccess = appFeedbackMessageSuccess;
const clearAppFeedbackMessage = () => {
    return { type: exports.CLEAR_APP_FEEDBACK_MESSAGE };
};
exports.clearAppFeedbackMessage = clearAppFeedbackMessage;
const setOnlineStatus = (data) => {
    return { type: exports.SET_ONLINE_STATUS, data };
};
exports.setOnlineStatus = setOnlineStatus;
const showSaveNeeded = (data) => {
    return { type: exports.SHOW_SAVE_NEEDED, data };
};
exports.showSaveNeeded = showSaveNeeded;
const saveNeededStarted = (data) => {
    return { type: exports.SAVE_NEED_STARTED, data };
};
exports.saveNeededStarted = saveNeededStarted;
const hideSaveNeeded = () => {
    return { type: exports.HIDE_SAVE_NEEDED };
};
exports.hideSaveNeeded = hideSaveNeeded;
// services
// used for the saveNeeded popup if user clicks 'Save Changes'
function doSave() {
    return (dispatch, getState) => {
        dispatch((0, exports.saveNeededStarted)((0, app_1.saveNeeded)(getState())));
        const onSave = (0, app_1.saveNeededOnSave)(getState());
        const onSaveError = (0, app_1.saveNeededOnSaveError)(getState());
        return onSave()
            .then(() => { })
            .catch(() => {
            if (onSaveError) {
                return onSaveError();
            }
        })
            .finally(() => {
            dispatch((0, exports.hideSaveNeeded)());
        });
    };
}
// used for the saveNeeded popup if user clicks 'Cancel'
function cancel() {
    return (dispatch, getState) => {
        const onCancel = (0, app_1.saveNeededCancel)(getState());
        onCancel && onCancel();
        dispatch((0, exports.hideSaveNeeded)());
    };
}
const timeoutFunc = (callback, timeout) => window.setTimeout(callback, timeout);
function checkConnectionStatusContinually() {
    return (dispatch, getState) => {
        const browserOnline = navigator.onLine;
        const appOnlineStatus = (0, app_1.online)(getState());
        if (appOnlineStatus !== browserOnline) {
            dispatch((0, exports.setOnlineStatus)(browserOnline));
        }
        timeoutFunc(checkConnectionStatusContinually, 1000);
    };
}
